import { BaseLinkButton, Body, H2, SecondaryButton } from '@rikstv/shared-components';

import { authService } from '../../utils/auth/AuthService';

import styles from './ErrorPage.module.css';

export const ErrorPage = () => (
  <article className={styles.errorPage}>
    <div className={styles.errorPageContent}>
      <H2>Au da, det har oppstått en feil</H2>
      <Body>Feilen er meldt inn til oss og vi skal forsøke å løse den. Klikk under for å gå til forsiden</Body>
      <br />
      {/* This page is outside our apps context, therefor cannot use the Link component */}
      <BaseLinkButton element="a" buttonStyle="primary" href="/">
        Til forsiden
      </BaseLinkButton>
      {/* A broken session can make the error come back on every page, so let the user start over */}
      {authService.isAuthenticated() && (
        <div className={styles.logout}>
          <Body>Står du fast? Prøv å logge ut og inn igjen.</Body>
          <SecondaryButton onClick={() => authService.logout()}>Logg ut</SecondaryButton>
        </div>
      )}
    </div>
  </article>
);
